import { useEffect, useMemo, useState } from "react";
import "./projects.css";
import { data } from "./data";
import { motion } from "framer-motion";
import { CgArrowLongRightR } from "react-icons/cg";
import reacticon from '../../assets/react.png'
import htmlicon from '../../assets/html.png'
import cssicon from '../../assets/css.png'
import jsicon from '../../assets/js.png'
import chakraicon from '../../assets/chakra.png'
import reduxicon from '../../assets/redux.png'
import openaiicon from '../../assets/openai.png'
import threeicon from '../../assets/three.png'
import stripeicon from '../../assets/stripe.png'
import nodejsicon from '../../assets/nodejs.png'
import mongodbicon from '../../assets/mongodb.png'
function Projects() {
  const MemoizedData = useMemo(() => data, []);
  const [works, setWorks] = useState([]);
  const [filterWork, setFilterWork] = useState([]);
  const [activeFilter, setActiveFilter] = useState("All");
  const [animateCard, setAnimateCard] = useState({ y: 0, opacity: 1 });
  const [showProjects, setShowProjects] = useState(3);
  const [closeProject, setcloseProject] = useState(false)
  const handleWorkFilter = (item) => {
    setActiveFilter(item);
    setAnimateCard([{ y: 100, opacity: 0 }]);

    setTimeout(() => {
      setAnimateCard([{ y: 0, opacity: 1 }]);

      if (item === 'All') {
        setFilterWork(works);
      } else {
        setFilterWork(works.filter((work) => work.tags.includes(item)));
      }
    }, 500);
  };
  useEffect(() => {
    setWorks(MemoizedData);
    setFilterWork(MemoizedData);
  }, []);
  return (
    <section id="projects">
      <motion.h5 whileInView={{ opacity: 1, y: 0 }}
      initial={{ opacity: 0, y: -50 }}
      transition={{
        duration:1.25,type: "spring",
      }}>My Projects</motion.h5>
      <motion.h2 whileInView={{ opacity: 1, y: 0 }}
      initial={{ opacity: 0, y: -50 }}
      transition={{
        duration:1.25,type: "spring",delay:0.3
      }}>Portfolio</motion.h2>
      <div
      >
        <div className="app__work-filter">
          {["All", "React JS",'Node JS','Mongo DB',"Redux",'Open AI','Three JS',"JavaScript", 'Chakra UI','Stripe'].map(
            (item, index) => (
              <div
                key={index}
                onClick={() => handleWorkFilter(item)}
                className={`app__work-filter-item app__flex ${
                  activeFilter === item ? "item-active" : ""
                }`}
              >
                {item}
              </div>
            )
          )}
          <motion.div
            animate={animateCard}
            transition={{ duration: 0.5, delayChildren: 0.5 }}
            className="app__work-portfolio"
          >
            {
            filterWork.slice(0, showProjects).map((work, index) => (
              <div className="app__work-item app__flex" key={index}>
                <div className="app__work-img app__flex">
                  <img src={work.image} alt={work.title} />
                  
                </div>
                <div className="project_techstacks">
            {
                work.tags.includes('React JS')? <img src={reacticon} alt="" /> : null
            }
              {
                  work.tags.includes('Redux')? <img src={reduxicon} alt="" /> : null
              }
              {
                  work.tags.includes('JavaScript')? <img src={jsicon} alt="" /> : null
              }
            {
                work.tags.includes('HTML')? <img src={htmlicon} alt="" /> : null
            }
            {
                work.tags.includes('CSS')? <img src={cssicon} alt="" /> : null
            }
            {
                work.tags.includes('Chakra UI')? <img src={chakraicon} alt="" /> : null
            }
            {
                work.tags.includes('Open AI')? <img src={openaiicon} alt="" /> : null
            }
            {
                work.tags.includes('Three JS')? <img src={threeicon} alt="" /> : null
            }
            {
                work.tags.includes('Stripe')? <img src={stripeicon} alt="" /> : null
            }
            {
                work.tags.includes('Node JS')? <img src={nodejsicon} alt="" /> : null
            }
            {
                work.tags.includes('Mongo DB')? <img src={mongodbicon} alt="" /> : null
            }
          </div>
                <div className="app__work-content app__flex">
              <h3 className="bold-text">{work.title}</h3>
              <p className="p-text">{work.des}</p>
              
            </div>
              <div className="portfolio_item_CTA">
                    <a href={work.github} className='btn' target='_blank' rel="noreferrer">Github</a>
                    <a href={work.live} className='btn btn-primary' target='_blank' rel="noreferrer">Live Demo</a>
                  </div>
              </div>
            ))}
          </motion.div>
          {
            filterWork.length>3?(<div className="projectCount">
              {
                !closeProject?<h2 className="showAll" onClick={() => {
                  setShowProjects(filterWork.length)
                  setcloseProject((prev)=>!prev)
                }}>Show All <CgArrowLongRightR /></h2>:<h2 className="showAll" onClick={() => {
                  setShowProjects(3)
                  setcloseProject((prev)=>!prev)
                }}>hide <CgArrowLongRightR /></h2>
              }
            
            
          </div>):null
          }
          
        </div>
      </div>
    </section>
  );
}

export default Projects;
